import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09d1cd88"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "image-slot" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = { class: "top" }
const _hoisted_4 = { class: "URL_text" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { style: {"margin-top":"8px"} }, null, -1))
const _hoisted_6 = { class: "top" }
const _hoisted_7 = { class: "bottom" }

import { ref, toRefs, onMounted, computed } from "vue";
import { SetTopBookMark, CancelTopBookMark } from "../http/index";
import { ElMessage } from "element-plus";


export default /*#__PURE__*/_defineComponent({
  __name: 'MainCard',
  props: {
  Book: {
    type: Array,
  },
},
  emits: ["GetBook"],
  setup(__props, { emit }) {

const props = __props;


const { Book } = toRefs(props);
onMounted(() => {
  console.log(Book?.value);
});
const jumpUrl = () => {
  window.open(Book?.value.Url);
};


const CancelGetBook = async () => {
  var res = (await CancelTopBookMark(Book?.value.Id)).data;
  if (res.status == 200) {
    ElMessage.success(`${res.msg}`);
    emit("GetBook");
  } else {
    ElMessage.error(`取消置顶失败：${res.msg}`);
  }
};
const setLoadGetBook = async () => {
  var res = (await SetTopBookMark(Book?.value.Id)).data;
  if (res.status == 200) {
    if(res.successful == false){
          ElMessage.warning(`${res.msg}`);
    }else{
    ElMessage.success(`${res.msg}`);
    }
  } else {
    ElMessage.error(`置顶失败：${res.msg}`);
  }
};

//解析url
const newurl = computed(()=>{
  var pattern = /[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\.?/  
  return 'https://api.iowen.cn/favicon/' + (Book?.value.Url).match(pattern)[0] +'.png'
})

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, null, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_el_image, {
          src: _unref(newurl),
          style: {"width":"25px","height":"25px"}
        }, {
          error: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-images" })
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["src"])
      ]),
      _createElementVNode("div", {
        class: "Card",
        onClick: jumpUrl
      }, [
        _createElementVNode("div", {
          class: "top top_text",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.jump()))
        }, [
          _createElementVNode("span", null, "书签名称：" + _toDisplayString(_unref(Book)?.Name), 1)
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", null, "当前分级：" + _toDisplayString(_unref(Book)?.Item) + "--" + _toDisplayString(_unref(Book)?.Children) + "级", 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", null, " URL：" + _toDisplayString(_unref(Book)?.Url), 1)
          ])
        ])
      ]),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          (_unref(Book).IsTop)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "primary",
                primary: "",
                class: "button",
                onClick: CancelGetBook
              }, {
                default: _withCtx(() => [
                  _createTextVNode("取消置顶")
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                type: "primary",
                primary: "",
                class: "button",
                onClick: setLoadGetBook
              }, {
                default: _withCtx(() => [
                  _createTextVNode("设置置顶")
                ]),
                _: 1
              }))
        ])
      ])
    ]),
    _: 1
  }))
}
}

})